import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';
import ImageError from 'assets/images/500.png';
import { Link } from 'react-router-dom';

function WentWrong() {
  return (
    <MDBox sx={{ textAlign: 'center', maxWidth: '400px' }}>
      <MDTypography sx={{ fontSize: '32px', fontWeight: '700', marginBottom: '1rem', lineHeight: '1.2' }}>Something went wrong</MDTypography>
      <MDTypography sx={{ fontWeight: '500', marginBottom: '2rem' }}>Try refreshing the page or come back later.</MDTypography>
      <MDBox sx={{ marginBottom: '1rem' }}>
        <img src={ImageError} alt='' />
      </MDBox>
      <Link to='/'>
        <MDButton color='info'>Retry</MDButton>
      </Link>
    </MDBox>
  );
}

export default WentWrong;
